// Local Dev environment, use port 8000
export const API_BASE_URI = process.env.REACT_APP_BACKEND_API_URL || "http://localhost:8000";

// Docker environment with nginx, use port 80. no port designation
// const protocol = window.location.protocol;
// const hostname = window.location.hostname;
// const port = window.location.port;
// export const API_BASE_URI = `${protocol}//${hostname}${port ? `:${port}` : ''}`;
export const API_AUTH_BASE_URI = `${API_BASE_URI}/api/oauth`;
export const API_PAF_BASE_URI = `${API_BASE_URI}/api/paf`;
